// THIS FILE IS AUTOGENERATED
import file0 from "!!raw-loader!./doc/advanced/bitnodes.md";
import file1 from "!!raw-loader!./doc/advanced/bladeburners.md";
import file2 from "!!raw-loader!./doc/advanced/corporations.md";
import file3 from "!!raw-loader!./doc/advanced/gang.md";
import file4 from "!!raw-loader!./doc/advanced/grafting.md";
import file5 from "!!raw-loader!./doc/advanced/hacknetservers.md";
import file6 from "!!raw-loader!./doc/advanced/intelligence.md";
import file7 from "!!raw-loader!./doc/advanced/sleeves.md";
import file8 from "!!raw-loader!./doc/advanced/sourcefiles.md";
import file9 from "!!raw-loader!./doc/advanced/stanek.md";
import file10 from "!!raw-loader!./doc/basic/augmentations.md";
import file11 from "!!raw-loader!./doc/basic/codingcontracts.md";
import file12 from "!!raw-loader!./doc/basic/companies.md";
import file13 from "!!raw-loader!./doc/basic/crimes.md";
import file14 from "!!raw-loader!./doc/basic/factions.md";
import file15 from "!!raw-loader!./doc/basic/hacking.md";
import file16 from "!!raw-loader!./doc/basic/hacknet_nodes.md";
import file17 from "!!raw-loader!./doc/basic/infiltration.md";
import file18 from "!!raw-loader!./doc/basic/ram.md";
import file19 from "!!raw-loader!./doc/basic/reputation.md";
import file20 from "!!raw-loader!./doc/basic/scripts.md";
import file21 from "!!raw-loader!./doc/basic/servers.md";
import file22 from "!!raw-loader!./doc/basic/stats.md";
import file23 from "!!raw-loader!./doc/basic/stockmarket.md";
import file24 from "!!raw-loader!./doc/basic/terminal.md";
import file25 from "!!raw-loader!./doc/basic/world.md";
import file26 from "!!raw-loader!./doc/changelog.md";
import file27 from "!!raw-loader!./doc/help/bitnode_order.md";
import file28 from "!!raw-loader!./doc/help/getting_started.md";
import file29 from "!!raw-loader!./doc/help/tools_and_resources.md";
import file30 from "!!raw-loader!./doc/index.md";
import file31 from "!!raw-loader!./doc/migrations/v1.md";
import file32 from "!!raw-loader!./doc/migrations/v2.md";
import file33 from "!!raw-loader!./doc/programming/game_frozen.md";
import file34 from "!!raw-loader!./doc/programming/hackingalgorithms.md";
import file35 from "!!raw-loader!./doc/programming/learn.md";
import file36 from "!!raw-loader!./doc/programming/remote_api.md";

interface Document {
  default: string;
}
export const AllPages: Record<string, Document> = {};
AllPages["advanced/bitnodes.md"] = file0;
AllPages["advanced/bladeburners.md"] = file1;
AllPages["advanced/corporations.md"] = file2;
AllPages["advanced/gang.md"] = file3;
AllPages["advanced/grafting.md"] = file4;
AllPages["advanced/hacknetservers.md"] = file5;
AllPages["advanced/intelligence.md"] = file6;
AllPages["advanced/sleeves.md"] = file7;
AllPages["advanced/sourcefiles.md"] = file8;
AllPages["advanced/stanek.md"] = file9;
AllPages["basic/augmentations.md"] = file10;
AllPages["basic/codingcontracts.md"] = file11;
AllPages["basic/companies.md"] = file12;
AllPages["basic/crimes.md"] = file13;
AllPages["basic/factions.md"] = file14;
AllPages["basic/hacking.md"] = file15;
AllPages["basic/hacknet_nodes.md"] = file16;
AllPages["basic/infiltration.md"] = file17;
AllPages["basic/ram.md"] = file18;
AllPages["basic/reputation.md"] = file19;
AllPages["basic/scripts.md"] = file20;
AllPages["basic/servers.md"] = file21;
AllPages["basic/stats.md"] = file22;
AllPages["basic/stockmarket.md"] = file23;
AllPages["basic/terminal.md"] = file24;
AllPages["basic/world.md"] = file25;
AllPages["changelog.md"] = file26;
AllPages["help/bitnode_order.md"] = file27;
AllPages["help/getting_started.md"] = file28;
AllPages["help/tools_and_resources.md"] = file29;
AllPages["index.md"] = file30;
AllPages["migrations/v1.md"] = file31;
AllPages["migrations/v2.md"] = file32;
AllPages["programming/game_frozen.md"] = file33;
AllPages["programming/hackingalgorithms.md"] = file34;
AllPages["programming/learn.md"] = file35;
AllPages["programming/remote_api.md"] = file36;
